import React from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./LessonsReport.css";
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const QuizInfo = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const pieData = [
    { name: "Watched", value: 3 },
    { name: "Not Watched", value: 18 },
  ];

  const COLORS = ["#8B5CF6", "#84CC16"];

  const dataDaily = [{ date: "Jan 31, 2024", count: 3 }];

  const dataPerCampaign = [
    {
      date: "Jan 31, 2024",
      EmailSecurity: 1,
      PasswordSecurity: 1,
      SafeBrowsing: 1,
    },
  ];

  return (
    <div className="container p-3">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <div className="pageTitle">{t("LessonReports")}</div>
        <Button variant="primary" onClick={() => navigate(-1)}>
          {t("Back")}
        </Button>
      </div>

      <Card className="shadow-sm mb-4 p-4 mb-4">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h5 className="mb-3">{t("VideoWatchStatus")}</h5>
            <PieChart width={180} height={180}>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={70}
                paddingAngle={2}
                dataKey="value"
              >
                {pieData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
            </PieChart>
          </div>
          <div className="col-md-6 text-end">
            <h3>21</h3>
            <p className="text-muted">{t("Total")}</p>
            <div className="mt-3">
              <div className="d-flex justify-content-end align-items-center mb-2">
                <span
                  className="me-2"
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: COLORS[0],
                  }}
                ></span>
                <span className="small">{t("Watched")} – 14.3%</span>
              </div>
              <div className="d-flex justify-content-end align-items-center">
                <span
                  className="me-2"
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: COLORS[1],
                  }}
                ></span>
                <span className="small">{t("NotWatched")} – 85.7%</span>
              </div>
            </div>
          </div>
        </div>
      </Card>

      <h3 className="fw-bold mb-4">{t("QuizInfo")}</h3>

      <div className="row g-4">
        <div className="col-md-6">
          <Card className="shadow-sm p-3">
            <h6 className="mb-3">{t("QuizTakenDaily")}</h6>
            <div className="force-ltr-chart">
              <ResponsiveContainer width="100%" height={385}>
                <BarChart data={dataDaily}>
                  <XAxis
                    dataKey="date"
                    interval={0}
                    padding={{ left: 20, right: 20 }}
                  />
                  <YAxis
                    type="number"
                    domain={[0, 10]}
                    ticks={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                  />
                  <Tooltip />
                  <Bar dataKey="count" fill="#4299e1" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Card>
        </div>

        <div className="col-md-6">
          <Card className="shadow-sm p-3">
            <div>
              <h6 className="mb-2">{t("QuizTakenDailyPerCampaign")}</h6>
              <div className="d-flex gap-3 mb-3">
                <div className="d-flex align-items-center gap-1">
                  <span
                    style={{
                      width: 14,
                      height: 14,
                      backgroundColor: "#facc15",
                      display: "inline-block",
                      borderRadius: "10px",
                    }}
                  ></span>
                  <small>{t("EmailSecurity")}</small>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <span
                    style={{
                      width: 14,
                      height: 14,
                      backgroundColor: "#fb923c",
                      display: "inline-block",
                      borderRadius: "10px",
                    }}
                  ></span>
                  <small>{t("PasswordSecurity")}</small>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <span
                    style={{
                      width: 14,
                      height: 14,
                      backgroundColor: "#38bdf8",
                      display: "inline-block",
                      borderRadius: "10px",
                    }}
                  ></span>
                  <small>{t("SafeBrowsing")}</small>
                </div>
              </div>
            </div>

            <div className="force-ltr-chart">
              <ResponsiveContainer width="100%" height={360}>
                <BarChart data={dataPerCampaign}>
                  <XAxis
                    dataKey="date"
                    interval={0}
                    padding={{ left: 20, right: 20 }}
                  />
                  <YAxis
                    type="number"
                    domain={[0, 10]}
                    ticks={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                  />
                  <Tooltip />
                  <Bar dataKey="EmailSecurity" stackId="a" fill="#facc15" />
                  <Bar dataKey="PasswordSecurity" stackId="a" fill="#fb923c" />
                  <Bar dataKey="SafeBrowsing" stackId="a" fill="#38bdf8" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default QuizInfo;
